import { RootState } from '../store';

// Message selectors
export const selectMessages = (state: RootState) => state.chat.messages;
export const selectIsTyping = (state: RootState) => state.chat.isTyping;
export const selectLastError = (state: RootState) => state.chat.lastError;

// Thread selectors
export const selectCurrentThreadId = (state: RootState) => state.chat.currentThreadId;
export const selectThreads = (state: RootState) => state.chat.threads;
export const selectThreadLoading = (state: RootState) => state.chat.threadLoading;

// Streaming selectors
export const selectStreamingStatus = (state: RootState) => state.chat.streamingStatus;
export const selectCurrentRunId = (state: RootState) => state.chat.currentRunId;

// Intermediate steps selectors
export const selectIntermediateSteps = (state: RootState) => state.chat.intermediateSteps;
export const selectShowIntermediateSteps = (state: RootState) => state.chat.showIntermediateSteps;

// Interrupt selectors
export const selectPendingInterrupt = (state: RootState) => state.chat.pendingInterrupt;

// Custom event selectors
export const selectCustomEventValues = (state: RootState) => state.chat.values;

// Current team selector
export const selectCurrentTeam = (state: RootState) => state.chat.currentTeam;

// Team leader selector
export const selectTeamLeader = (state: RootState) => state.chat.teamLeader;

// Stream abort token — incremented whenever messages are cleared to invalidate in-flight streams
export const selectStreamAbortToken = (state: RootState) => state.chat.streamAbortToken;
